import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { FILTERS } from './filters-helpers'
import { setColorTheme } from 'theme/utils/generic-helpers'
import { useDropdown } from 'theme/hooks/useDropdown'
import { useApp } from 'theme/services/app-service'

const FiltersNav = ({
  allFilters,
  currentFilters,
  changeFilters,
  conferenceLocation,
  conferenceTimezone,
  filters,
  noTop,
}) => {
  const appInfo = useApp()
  const isLiveProject = appInfo?.app?.appName === 'speakers'
  const displayFilters = filters.split(' ')
  const [triggerDropdownRef, dropdownRef, dropdownOpen, setDropdownOpen] = useDropdown()

  const handleTypeFilter = (type) => changeFilters(FILTERS.TYPE, type)
  const handleDayFilter = (day) => changeFilters(FILTERS.DAY, day)

  // const handleSessionTypeFilter = (sessionTypesValues) => {
  //   const sessionTypes = sessionTypesValues ? sessionTypesValues.map((sessionType) => sessionType.label) : []

  //   changeFilters(FILTERS.SESSION_TYPE, sessionTypes)
  // }
  const handleConferenceTypeFilter = (conferenceTypesValues) => {
    const conferenceTypes = conferenceTypesValues
      ? conferenceTypesValues.map((conferenceType) => conferenceType.label)
      : []

    changeFilters(FILTERS.CONFERENCE_TYPE, conferenceTypes)
  }
  const handleFormatFilter = (formatsValues) => {
    const formats = formatsValues ? formatsValues.map((format) => format.label) : []

    changeFilters(FILTERS.FORMAT, formats)
  }
  // const handleDeliveryFilter = (deliveriesValues) => {
  //   const deliveries = deliveriesValues ? deliveriesValues.map((delivery) => delivery.label) : []

  //   changeFilters(FILTERS.DELIVERY, deliveries)
  // }
  const handleDeliveryLocationFilter = (deliveryLocationsValues) => {
    const locations = deliveryLocationsValues ? deliveryLocationsValues.map((location) => location.label) : []

    changeFilters(FILTERS.LOCATIONS, locations)
  }

  const handleStreamsFilter = (streamsValues) => {
    const streams = streamsValues ? streamsValues.map((stream) => stream.label) : []

    changeFilters(FILTERS.STREAM, streams)
  }

  const handleStagesFilter = (stagesValues) => {
    const stages = stagesValues ? stagesValues.map((stage) => stage.label) : []

    changeFilters(FILTERS.STAGE, stages)
  }

  const isSessionFavouriteSelected = (selectedFilter) => {
    return currentFilters.type === selectedFilter
  }

  const isDayTabSelected = (selectedFilter) => {
    return currentFilters.date === selectedFilter
  }

  const getNumberOfFiltersSet = () => {
    return (
      currentFilters.conferenceTypes.length +
      currentFilters.streams.length +
      currentFilters.stages.length +
      currentFilters.formats.length +
      currentFilters.deliveries.length +
      currentFilters.locations.length
    )
  }

  const getFilterDay = (datetime, timezone) => {
    var parts = datetime.split('/')
    var month = parseInt(parts[0], 10) - 1 // JavaScript months are zero-based
    var day = parseInt(parts[1], 10)
    var year = parseInt(parts[2], 10)
    const date = new Date(year, month, day)
    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }
    if (timezone && timezone != 'Etc/Unknown') options.timeZone = timezone
    let utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
    let tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }))
    let offset = utcDate.getTime() - tzDate.getTime()
    date.setTime(date.getTime() + offset - date.getTimezoneOffset() * 60 * 1000)
    return date.toLocaleString('en-GB', options)
  }

  // const getSessionTypeOptions = () => {
  //   return allFilters.sessionTypes.map((sessionType, idx) => ({
  //     value: idx,
  //     label: sessionType
  //   }))
  // }
  const getConferenceTypeOptions = () => {
    return allFilters.conferenceTypes.map((conferenceType, idx) => ({
      value: idx,
      label: conferenceType,
    }))
  }
  const getFormatOptions = () => {
    return allFilters.formats.map((format, idx) => ({
      value: idx,
      label: format,
    }))
  }
  // const getDeliveryOptions = () => {
  //   return allFilters.deliveries.map((delivery, idx) => ({
  //     value: idx,
  //     label: delivery,
  //   }))
  // }
  const getDeliveryLocationOptions = () => {
    return allFilters.locations.map((location, idx) => ({
      value: idx,
      label: location,
    }))
  }

  const getStreamsOptions = () => {
    return allFilters.streams.map((stream, idx) => ({
      value: idx,
      label: stream,
    }))
  }

  const getStagesOptions = () => {
    return allFilters.stages.map((stage, idx) => ({
      value: idx,
      label: stage,
    }))
  }

  // const getSelectedSessionTypes = () => {
  //   const allOptions = getSessionTypeOptions()

  //   return currentFilters.sessionTypes.length ? allOptions.filter((item) => currentFilters.sessionTypes.find((sessionType) => item.label === sessionType)) : []
  // }
  const getSelectedConferenceTypes = () => {
    const allOptions = getConferenceTypeOptions()

    return currentFilters.conferenceTypes.length
      ? allOptions.filter((item) =>
          currentFilters.conferenceTypes.find((conferenceType) => item.label === conferenceType),
        )
      : []
  }
  const getSelectedFormats = () => {
    const allOptions = getFormatOptions()

    return currentFilters.formats.length
      ? allOptions.filter((item) => currentFilters.formats.find((format) => item.label === format))
      : []
  }
  // const getSelectedDeliveries = () => {
  //   const allOptions = getDeliveryOptions()

  //   return currentFilters.deliveries.length
  //     ? allOptions.filter((item) => currentFilters.deliveries.find((delivery) => item.label === delivery))
  //     : []
  // }
  const getSelectedDeliveryLocations = () => {
    const allOptions = getDeliveryLocationOptions()

    return currentFilters.locations.length
      ? allOptions.filter((item) => currentFilters.locations.find((location) => item.label === location))
      : []
  }

  const getSelectedStreams = () => {
    const allOptions = getStreamsOptions()

    return currentFilters.streams.length
      ? allOptions.filter((item) => currentFilters.streams.find((stream) => item.label === stream))
      : []
  }

  const getSelectedStages = () => {
    const allOptions = getStagesOptions()

    return currentFilters.stages.length
      ? allOptions.filter((item) => currentFilters.stages.find((stage) => item.label === stage))
      : []
  }

  return (
    <div
      className={`${
        noTop ? 'top-0' : 'top-24'
      } lg:flex lg:items-center lg:justify-between max-w-screen-xl mx-auto px-6 lg:sticky bg-white z-10 border-b-2 border-gray-100`}
    >
      <div className="flex-1 min-w-0">
        <div className="mt-1 flex sm:mt-0 flex-row flex-wrap justify-between">
          <div className="mt-2 flex items-center justify-start text-sm leading-5 text-gray-500 sm:mr-6 order-2 lg:order-1">
            <nav className="-mb-px flex">
              <button
                onClick={() => handleTypeFilter()}
                className={`whitespace-nowrap flex md:ml-4 sm:ml-8 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                  ${
                    isSessionFavouriteSelected()
                      ? setColorTheme(
                          'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                          conferenceLocation,
                          filters,
                        )
                      : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                  }
                `}
              >
                <svg
                  className="w-5 h-5 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
                All <span className="hidden lg:block">Sessions</span>
              </button>
              {!isLiveProject && (
                <button
                  onClick={() => handleTypeFilter('favourite')}
                  className={`whitespace-nowrap flex ml-4 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                  ${
                    isSessionFavouriteSelected('favourite')
                      ? setColorTheme(
                          'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                          conferenceLocation,
                        )
                      : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                  }
                `}
                >
                  <svg
                    className="w-5 h-5 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    />
                  </svg>
                  Starred <span className="hidden lg:block">Sessions</span>
                </button>
              )}
            </nav>
          </div>
          {allFilters.days.length > 1 && displayFilters.indexOf('day') !== -1 && (
            <div className="hidden mt-2 md:flex items-center sm:justify-center text-sm leading-5 text-gray-500 sm:mr-6 order-1 lg:order-2 w-full lg:w-auto">
              <nav data-cy="sessions-days-list" className="-mb-px flex flex-wrap">
                <button
                  onClick={() => handleDayFilter()}
                  className={`whitespace-nowrap md:ml-4 sm:ml-8 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                    ${
                      isDayTabSelected()
                        ? setColorTheme(
                            'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                            conferenceLocation,
                          )
                        : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                    }
                  `}
                >
                  All Days
                </button>
                {allFilters.days.map((day, idx) => {
                  return (
                    <button
                      key={idx}
                      onClick={() => handleDayFilter(day)}
                      className={`whitespace-nowrap ml-4 lg:ml-3 xl:ml-4 sm:ml-8 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                      ${
                        isDayTabSelected(day)
                          ? setColorTheme(
                              'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                              conferenceLocation,
                            )
                          : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                      }
                    `}
                    >
                      {/* {new Date(day).toUTCString().split(' ').slice(0, 3).join(' ')} */}
                      {getFilterDay(day, conferenceTimezone)}
                    </button>
                  )
                })}
              </nav>
            </div>
          )}
          <div className="md:relative mt-2 flex items-center justify-start sm:justify-end text-sm leading-5 text-gray-500 sm:mr-6 order-3">
            <span className="rounded-md">
              <button
                ref={triggerDropdownRef}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`inline-flex items-center justify-center w-full md:ml-4 sm:ml-8 py-4 px-1 text-sm font-medium text-gray-500 transition duration-150 ease-in-out focus:outline-none active:outline-none
                        ${
                          getNumberOfFiltersSet() > 0
                            ? setColorTheme(
                                'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                                conferenceLocation,
                              )
                            : ''
                        }
                      `}
              >
                {/* <!-- Heroicon name: filter --> */}
                <svg
                  className="flex-shrink-0 mr-1.5 h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                  />
                </svg>
                <span className="hidden sm:block">Filters</span>{' '}
                {getNumberOfFiltersSet() > 0 ? '(' + getNumberOfFiltersSet() + ')' : ''}
              </button>
            </span>

            {dropdownOpen && (
              <div ref={dropdownRef}>
                <div className="absolute z-10 w-full md:w-auto pb-6 overflow-auto right-0 mt-6 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none">
                  {/* The faded colours are inactive. The deeper colours are the active versions */}
                  {/* {allFilters.sessionTypes.length > 0 && displayFilters.indexOf('sessionType') !== -1 && (
                    <div className='px-6 py-4'>
                      <div className='w-full text-base text-gray-900 mb-2'>Session Types</div>
                      <div className='flex'>
                        <div className='w-64 border-r border-gray-100 pr-2'>
                          <Select
                            defaultValue={getSelectedSessionTypes()}
                            onChange={handleSessionTypeFilter}
                            options={getSessionTypeOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )} */}
                  {allFilters.days.length > 1 && displayFilters.indexOf('day') !== -1 && (
                    <div className="mt-2 px-6 flex md:hidden items-center justify-between text-sm leading-5 text-gray-500 sm:mr-6 order-1 lg:order-2 w-full">
                      <nav data-cy="sessions-days-list" className="-mb-px flex flex-wrap">
                        <button
                          onClick={() => handleDayFilter()}
                          className={`whitespace-nowrap mr-8 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                    ${
                      isDayTabSelected()
                        ? setColorTheme(
                            'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                            conferenceLocation,
                          )
                        : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                    }
                  `}
                        >
                          All Days
                        </button>
                        {allFilters.days.map((day, idx) => {
                          return (
                            <button
                              key={idx}
                              onClick={() => handleDayFilter(day)}
                              className={`whitespace-nowrap mr-8 py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none
                      ${
                        isDayTabSelected(day)
                          ? setColorTheme(
                              'border-emea-600 text-emea-600 focus:text-emea-800 focus:border-emea-700 border-usa-600 text-usa-600 focus:text-usa-800 focus:border-usa-700 border-apac-600 text-apac-600 focus:text-apac-800 focus:border-apac-700 border-community-600 text-community-600 focus:text-community-800 focus:border-community-700',
                              conferenceLocation,
                            )
                          : 'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300 hover:border-gray-300'
                      }
                    `}
                            >
                              {/* {new Date(day).toUTCString().split(' ').slice(0, 3).join(' ')} */}
                              {getFilterDay(day, conferenceTimezone)}
                            </button>
                          )
                        })}
                      </nav>
                    </div>
                  )}

                  {allFilters.conferenceTypes.length > 0 &&
                    displayFilters.indexOf('conferenceType') !== -1 && (
                      <div className="px-6 py-2">
                        <div className="w-full text-base text-gray-900 mb-2">Conference Types</div>
                        <div className="flex">
                          <div className="w-64 border-r border-gray-100 pr-2">
                            <Select
                              defaultValue={getSelectedConferenceTypes()}
                              onChange={handleConferenceTypeFilter}
                              options={getConferenceTypeOptions()}
                              isMulti
                            />
                          </div>
                        </div>
                      </div>
                    )}

                  {allFilters.formats.length > 0 && displayFilters.indexOf('format') !== -1 && (
                    <div className="px-6 py-2">
                      <div className="w-full text-base text-gray-900 mb-2">Format</div>
                      <div className="flex">
                        <div className="w-64 border-r border-gray-100 pr-2">
                          <Select
                            defaultValue={getSelectedFormats()}
                            onChange={handleFormatFilter}
                            options={getFormatOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {allFilters.streams.length > 0 && displayFilters.indexOf('stream') !== -1 && (
                    <div className="px-6 py-2">
                      <div className="w-64 text-base text-gray-900 mb-2">Streams</div>
                      <div className="flex">
                        <div className="w-full border-r border-gray-100 pr-2">
                          <Select
                            defaultValue={getSelectedStreams()}
                            onChange={handleStreamsFilter}
                            options={getStreamsOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {allFilters.deliveries.length > 0 && displayFilters.indexOf('delivery') !== -1 && (
                    <div className="px-6 py-2">
                      <div className="w-full text-base text-gray-900 mb-2">Delivery Time</div>
                      <div className="flex">
                        <div className="w-64 border-r border-gray-100 pr-2">
                          <Select
                            defaultValue={getSelectedDeliveries()}
                            onChange={handleDeliveryFilter}
                            options={getDeliveryOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )} */}

                  {allFilters.locations.length > 0 && displayFilters.indexOf('delivery') !== -1 && (
                    <div className="px-6 py-2">
                      <div className="w-full text-base text-gray-900 mb-2">Delivery Location</div>
                      <div className="flex">
                        <div className="w-64 border-r border-gray-100 pr-2">
                          <Select
                            defaultValue={getSelectedDeliveryLocations()}
                            onChange={handleDeliveryLocationFilter}
                            options={getDeliveryLocationOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {allFilters.stages.length > 0 && displayFilters.indexOf('stage') !== -1 && (
                    <div className="px-6 py-2">
                      <div className="w-64 text-base text-gray-900 mb-2">Stages</div>
                      <div className="flex">
                        <div className="w-full border-r border-gray-100 pr-2">
                          <Select
                            defaultValue={getSelectedStages()}
                            onChange={handleStagesFilter}
                            options={getStagesOptions()}
                            isMulti
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

FiltersNav.propTypes = {
  allFilters: PropTypes.object.isRequired,
  currentFilters: PropTypes.object.isRequired,
  changeFilters: PropTypes.func.isRequired,
  conferenceLocation: PropTypes.string.isRequired,
  filters: PropTypes.string.isRequired,
  noTop: PropTypes.bool,
}

export default FiltersNav
